

import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

const AddBook = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    id: "",
    title: "",
    titleAm: "",
    author: "",
    authorAm: "",
    description: "",
    descriptionAm: "",
    category: "",
    categoryAm: "",
    coverUrl: "",
    pdfUrl: "",
    pages: "",
    language: "both",

    // keep as string input (JSON text)
    chapters: "",
    pageRangePdfs: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ required validation
    if (!formData.id || !formData.title || !formData.titleAm || !formData.pdfUrl) {
      setError("Please fill required fields (id, title, titleAm, pdfUrl)");
      return;
    }

    // ✅ FIX: parse JSON fields safely
    let parsedChapters = [];
    let parsedPageRanges = [];

    try {
      parsedChapters = formData.chapters
        ? JSON.parse(formData.chapters)
        : [];

      parsedPageRanges = formData.pageRangePdfs
        ? JSON.parse(formData.pageRangePdfs)
        : [];
    } catch (err) {
      setError("Invalid JSON format for Chapters or PageRangePdfs");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/books`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          pages: Number(formData.pages || 0),

          // ✅ FIXED: send correct structure
          chapters: parsedChapters,
          pageRangePdfs: parsedPageRanges,
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSuccess(result.message || "Book added successfully");

        // reset form (same structure preserved)
        setFormData({
          id: "",
          title: "",
          titleAm: "",
          author: "",
          authorAm: "",
          description: "",
          descriptionAm: "",
          category: "",
          categoryAm: "",
          coverUrl: "",
          pdfUrl: "",
          pages: "",
          language: "both",
          chapters: "",
          pageRangePdfs: "",
        });
      } else {
        setError(result.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error adding book:", error);
      setError("Server error, try again later");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Add Book
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>

          <Grid item xs={12} md={6}>
            <TextField label="Book ID" fullWidth name="id" value={formData.id} onChange={handleChange} required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Title" fullWidth name="title" value={formData.title} onChange={handleChange} required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Title (Amharic)" fullWidth name="titleAm" value={formData.titleAm} onChange={handleChange} required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Author" fullWidth name="author" value={formData.author} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Author (Amharic)" fullWidth name="authorAm" value={formData.authorAm} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Category" fullWidth name="category" value={formData.category} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Category (Amharic)" fullWidth name="categoryAm" value={formData.categoryAm} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Description" fullWidth multiline rows={3} name="description" value={formData.description} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Description (Amharic)" fullWidth multiline rows={3} name="descriptionAm" value={formData.descriptionAm} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Cover URL" fullWidth name="coverUrl" value={formData.coverUrl} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="PDF URL" fullWidth name="pdfUrl" value={formData.pdfUrl} onChange={handleChange} required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Pages" type="number" fullWidth name="pages" value={formData.pages} onChange={handleChange} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Language" fullWidth name="language" value={formData.language} onChange={handleChange} />
          </Grid>

          {/* ✅ JSON INPUT FIELDS */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Chapters (JSON)"
              fullWidth
              multiline
              rows={4}
              name="chapters"
              value={formData.chapters}
              onChange={handleChange}
              placeholder='[{"id":"ch1","title":"Chapter 1"}]'
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="PageRangePdfs (JSON)"
              fullWidth
              multiline
              rows={4}
              name="pageRangePdfs"
              value={formData.pageRangePdfs}
              onChange={handleChange}
              placeholder='[{"startPage":1,"endPage":10}]'
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained" startIcon={<CloudUploadIcon />}>
              Add Book
            </Button>
          </Grid>

        </Grid>
      </form>

      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)} message={error} />
      <Snackbar open={!!success} autoHideDuration={6000} onClose={() => setSuccess(null)} message={success} />
    </Box>
  );
};

export default AddBook;